module.exports = __webpack_public_path__ + "img/banner.314e33f5.png";